module.exports = __webpack_public_path__ + "media/images/bg/hero/saska-pricing-229bf88979fdc4ba441a3efb0ec36656.jpg";